import { useTranslation } from "react-i18next";
import type { VersionStatus } from "@/types";

const STATUS_COLORS: Partial<
  Record<VersionStatus, { bg: string; color: string }>
> = {
  developing: { bg: "rgba(0,0,0,0.04)", color: "rgba(0,0,0,0.65)" },
  reviewing: { bg: "rgba(255,141,40,0.08)", color: "#FF8D28" },
  rejected: { bg: "rgba(245,63,63,0.08)", color: "#F53F3F" },
  scheduled: { bg: "rgba(0,136,255,0.08)", color: "#0088FF" },
  released: { bg: "rgba(0,180,42,0.08)", color: "#00B42A" },
  delisted: { bg: "rgba(0,0,0,0.06)", color: "rgba(0,0,0,0.45)" },
  disabled: { bg: "rgba(245,63,63,0.08)", color: "#F53F3F" },
  archived: { bg: "rgba(0,0,0,0.04)", color: "rgba(0,0,0,0.45)" },
  rolling_back: { bg: "rgba(99,102,241,0.08)", color: "#6366F1" },
};

export function StatusTag({
  status,
  compact,
}: {
  status: VersionStatus;
  /** Slightly smaller for dense sidebar rows */
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const c = STATUS_COLORS[status] ?? STATUS_COLORS.developing!;
  return (
    <span
      style={{
        display: "inline-flex",
        height: compact ? 20 : 24,
        alignItems: "center",
        padding: compact ? "0 6px" : "0 8px",
        borderRadius: 6,
        fontSize: 12,
        lineHeight: 1,
        background: c.bg,
        color: c.color,
        flexShrink: 0,
      }}
    >
      {t(`versions.status_${status}` as const)}
    </span>
  );
}
